import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { CandidateAdapter } from '@shared/models';

@Component({
  selector: 'mojo-candidate-contact',
  templateUrl: './candidate-contact.component.html',
  styleUrls: ['./candidate-contact.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CandidateContactComponent {
  @Input() candidate: CandidateAdapter;
  @Input() verticalLayout: boolean;
  @Input() includeResumeButton = true;
  @Input() includeContactButtons = true;
  @Input() candidateCard = false;
  @Input() hideResumeDownloadButton = false;
  @Input() showQA = false;

  constructor() {}
}
